var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ListSearch',{attrs:{"item-name":"Account","get-search-client":_vm.getSearchClient,"get-search-parameters":_vm.getSearchParameters,"on-reset":_vm.onReset},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var account = ref.item;
return [_c('AccountListItem',{attrs:{"account":_vm.processSearchResult(account)}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }